
import React from 'react';
import { Button } from '@/components/ui/button';
import { CreditCard } from 'lucide-react';

interface AdvancedTransferButtonProps {
  text: string;
  onClick: () => void;
}

const AdvancedTransferButton: React.FC<AdvancedTransferButtonProps> = ({ text, onClick }) => {
  return (
    <Button 
      variant="outline" 
      onClick={onClick}
      className="w-full flex items-center justify-center gap-2 mb-6"
    >
      <CreditCard className="h-4 w-4" />
      {text}
    </Button>
  );
};

export default AdvancedTransferButton;
